import { z } from "zod";

export const getVehiclesSivDataListByCompaniesRequest = z.object({
  companyUuids: z.array(z.uuid()),
});

export type GetVehiclesSivDataListByCompaniesRequest = z.infer<
  typeof getVehiclesSivDataListByCompaniesRequest
>;
